<template>
  <div :id="id" :style="{ height: height, width: width }"></div>
</template>
<script>
import * as echarts from 'echarts'
import resize from './mixins/resize'
// let color = []
export default {
  mixins: [resize],
  props: {
    option: {
      type: Object,
      default: () => {
        return {}
      }
    },
    name: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '200px'
    }
  },
  data () {
    return {
      chart: null,
      defaultOptions: {}
    }
  },
  watch: {
    option: {
      handler (newValue, oldValue) {
        this.initChart()
      },
      deep: true
    }
  },
  mounted () {
    this.initChart()
  },
  beforeDestroy () {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initChart () {
      const isAndroid = this.$store.state.app.isAndroid
      this.chart = echarts.init(document.getElementById(this.id), {}, { renderer: 'svg' })
      const pieOption = {
        title: this.option.title || {},
        legend: {
          itemWidth: !isAndroid ? 10 : 5,
          itemHeight: !isAndroid ? 10 : 5,
          itemGap: 8,
          top: !isAndroid ? 10 : 20,
          right: 20,
          textStyle: {
            fontSize: !isAndroid ? 12 : 8,
            color: '#F1F1F3'
          },
          ...this.option.legend
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          //   formatter: function (params) {
          //     var relVal = params[0].name
          //     let dw = '万元'
          //     for (var i = 0, l = params.length; i < l; i++) {
          //       if (params[i].seriesName.includes('数量')) {
          //         dw = '台'
          //       }
          //       relVal += '<br/>' + params[i].marker + params[i].seriesName + ' : ' + params[i].value + dw
          //     return relVal
          //   }
          formatter: function (params) {
            if (params.length < 4) {
              var relVal = params[0].name
              let dw = '万元'
              for (var i = 0, l = params.length; i < l; i++) {
                if (params[i].seriesName.includes('数量')) {
                  dw = '台'
                }
                relVal += '<br/>' + params[i].marker + params[i].seriesName + ' : ' + params[i].value + dw
              }
              return relVal
            }
            var res = ''
            res += "<div class='nodeInfo'>"
            res += '<div>' + params[0].axisValue + '</div>'
            res += '<div>实时出库</div>'
            res += '<div>' + params[2].value + '台 / ' + params[1].value + '万元</div>'
            res += '<div>实时销售</div>'
            res += '<div>' + params[3].value + '台 / ' + params[0].value + '万元</div>'
            res += '</div>'
            return res
          }
        },
        color: this.option.color ? this.option.color : ['#1ee4dc', '#ffd71a', '#1ee4dc', '#ffd71a', '#3ED5FF', '#F07028', '#06C49C', '#FFB000', '#FA4300', '#FFFFFF'],
        grid: this.option.grid || {
          left: 10,
          right: 20,
          bottom: 10,
          top: 20,
          containLabel: true
        },
        xAxis: this.option.xAxis && this.option.xAxis.length > 0 ? this.option.xAxis : [
          {
            type: 'category',
            boundaryGap: !!this.option.boundaryGap,
            data: this.option.xData,
            axisLine: {
              lineStyle: {
                color: 'rgba(255,255,255,.1)'
              }
            },
            axisLabel: {
              // rotate: 90,
              textStyle: {
                color: 'rgba(255,255,255,.6)',
                fontSize: !isAndroid ? 12 : 10
              }
            },
            axisTick: {
              alignWithLabel: !!this.option.alignWithLabel
            },
            ...this.option.xAxis
          }
        ],
        yAxis: this.option.yAxis && this.option.yAxis.length > 0 ? this.option.yAxis : [
          {
            type: 'value',
            splitLine: {
              lineStyle: {
                color: 'rgba(255,255,255,0.1)'
              }
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: 'rgba(255,255,255,.1)'
              }
            },
            axisLabel: {
              textStyle: {
                color: 'rgba(255,255,255,.6)',
                fontSize: !isAndroid ? 12 : 10
              }
            },
            nameTextStyle: {
              color: '#999',
              fontSize: !isAndroid ? 12 : 10
            },
            splitNumber: 2,
            ...this.option.yAxis
          }
        ],
        series: this.option.series
      }
      this.chart.setOption(pieOption)
    }
  },
  created () {}
}
</script>
